import { render, staticRenderFns } from "./ListagemCotacaoHeader.vue?vue&type=template&id=fd8a0606"
import script from "./ListagemCotacaoHeader.vue?vue&type=script&lang=js"
export * from "./ListagemCotacaoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports